import { lazy } from "react";
import type { RouteConfig } from "../types";
import { ComponentSuspense } from "@/components/ui/suspense-wrapper";

// Process pages
const ProcessNames = lazy(
  () => import("@/pages/app/admin/process/process-names")
);
const ProcessesInFolder = lazy(
  () => import("@/pages/app/admin/process/processes-in-folder")
);
const ProcessDisabled = lazy(
  () => import("@/pages/app/admin/process/process-disabled")
);
const ProcessDesign = lazy(
  () => import("@/pages/app/admin/process/process-design")
);
const CertificateTemplateManager = lazy(
  () => import("@/pages/app/admin/certificate/certificate-template-manager")
);

export const adminProcessRoutes: RouteConfig[] = [
  // Process routes
  {
    path: "admin/processes",
    element: (
      <ComponentSuspense>
        <ProcessNames />
      </ComponentSuspense>
    ),
    meta: {
      title: "Process Names | UzaForm",
      description: "Manage process names and configurations",
    },
  },
  {
    path: "admin/process/folder/:folderId",
    element: (
      <ComponentSuspense>
        <ProcessesInFolder />
      </ComponentSuspense>
    ),
    meta: {
      title: "Processes in Folder | UzaForm",
      description: "View and manage processes in a specific folder",
    },
  },
  {
    path: "admin/process/process-disabled",
    element: (
      <ComponentSuspense>
        <ProcessDisabled />
      </ComponentSuspense>
    ),
    meta: {
      title: "Disabled Processes | UzaForm",
      description: "View and manage disabled processes",
    },
  },
  {
    path: "admin/process/process-design/:processId",
    element: (
      <ComponentSuspense>
        <ProcessDesign />
      </ComponentSuspense>
    ),
    meta: {
      title: "Process Design | UzaForm",
      description: "Design and configure processes",
    },
  },
  {
    path: "admin/certificate/template/:processId",
    element: (
      <ComponentSuspense>
        <CertificateTemplateManager />
      </ComponentSuspense>
    ),
    meta: {
      title: "Certificate Template Manager | UzaForm",
      description: "Manage certificate templates and field mappings",
    },
  },
];
